/*=============================================== StickyPage ===============================================*/

import { Link } from "react-router-dom"
import { Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const StickyPage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Text>
                    <Link
                        to="/components/sticky/demo"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: "<Sticky>\n    \n</Sticky>",
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "top",
            intro: "Position from the top of the page.",
            type: "string or number",
            possible: commonProps.spacers,
            default: "s",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default StickyPage
